<template>
  <div class="base-card">
    <header class="base-card__header">
      <slot name="title">{{ title }}</slot>
      <span
        v-if="collapse"
        class="base-card__collapse-btn"
        @click="handleClick"
      >
        {{ btnText }}
        <i :class="`icon-double-arrow-${isCollapsed ? 'down' : 'up'}`"></i>
      </span>
    </header>
    <el-collapse-transition>
      <main
        v-show="!collapse || !isCollapsed"
        class="base-card__body"
      >
        <slot>{{ content }}</slot>
      </main>
    </el-collapse-transition>
  </div>
</template>

<script>
export default {
  name: 'BaseCard',

  props: {
    title: String,
    content: String,
    collapse: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    btnText () {
      return this.isCollapsed ? '展开详情' : '收起详情'
    }
  },

  watch: {
    value: {
      handler (val) {
        this.isCollapsed = val
      },
      immediate: true
    }
  },

  data () {
    return {
      isCollapsed: true
    }
  },

  methods: {
    handleClick () {
      const value = !this.isCollapsed
      this.isCollapsed = value
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .base-card {
    position: relative;
    margin: 20px auto;
    min-height: 40px;
    border-radius: 4px;
    border: 1px solid transparent;
    .base-card__header {
      position: absolute;
      background-color: $--color-primary;
      width: 100%;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      color: #fff;
      text-align: center;
      border-radius: 4px 4px 0 0;
      z-index: 3;
    }
    .base-card__body {
      padding:  60px 20px 20px;
      height: 100%;
      border: 1px solid $--border-color-light-1;
      border-top-width: 0;
      border-radius: 0 0 4px 4px;
    }
    .base-card__collapse-btn {
      position: absolute;
      right: 20px;
      user-select: none;
      cursor: pointer;
      font-size: 12px;
      opacity: 0.8;
      transition: all 0.3s ease;
      &:hover {
        opacity: 1;
      }
    }
  }
</style>
